import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card1 from "../Images/NewsFeeds/BSUL/1.jpg";
import Card4 from "../Images/NewsFeeds/BSUL/2.jpg";
import Card3 from "../Images/NewsFeeds/BSUL/3.jpg";

export function AfricanBiogasCarbon() {
  return (
    <div className="art-page">
      <SEO
        title="Carbon Monitoring and Biogas User Surveys — African Biogas Carbon Programme"
        description="CIRCODU conducted sustained carbon monitoring and biogas user surveys for the African Biogas Carbon Programme over seven years, documenting household biogas adoption, fuel savings, and environmental impacts across regions."
        keywords="biogas, carbon monitoring, African Biogas Carbon Programme, household biogas, clean energy Uganda, biogas user surveys, carbon credit, emission reductions, sustainable energy, rural energy solutions, biogas adoption, fuel savings, environmental impact, CIRCODU, biogas carbon monitoring Uganda, biogas user surveys Uganda, African Biogas Carbon Programme Uganda, household biogas adoption Uganda, clean energy solutions Uganda, carbon credit initiatives Uganda, emission reduction verification Uganda, sustainable energy projects Uganda"
        url="/Carbon-Monitoring-and-Biogas-User-Surveys-African-Biogas-Carbon-Programme"
        image={Card1}
        datePublished="2025-12-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Carbon Monitoring and Biogas User Surveys — African Biogas Carbon
              Programme
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              December 01, 2025
            </div>
            <h1 className="art-title">
              Carbon Monitoring and Biogas User Surveys — African Biogas Carbon
              Programme (2018–2025)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                Over a sustained{" "}
                <strong>seven-year engagement spanning 2018 to 2025</strong>,
                CIRCODU served as the field monitoring organisation for the{" "}
                <strong>
                  African Biogas Carbon Programme's Uganda component
                </strong>{" "}
                — a Gold Standard-registered carbon project operated by{" "}
                <strong>Biogas Solutions Uganda Limited (BSUL)</strong> with
                support from the{" "}
                <strong>African Biogas Partnership Programme</strong>. CIRCODU's
                role was to conduct the annual and periodic Carbon Monitoring
                and Biogas User Surveys (CM-BUS) required to verify emission
                reductions and renew crediting periods under Gold Standard and
                CDM regulations.
              </p>
              <img
                src={Card1}
                alt="Model Biogas Digester System"
                className="art-img"
              />
              <h2 className="art-subheading">Progression of the Engagement</h2>
              <ol>
                <li>
                  <strong>2018–2021 (Periods I–III):</strong> Documentation of
                  functional bio-digesters, user feedback on operational
                  performance, and fuel consumption measurements across four
                  consecutive monitoring days per household — the core data
                  needed to calculate emission reduction credits.
                </li>
                <li>
                  <strong>December 2021:</strong> Dedicated biogas baseline
                  survey supporting the renewal of the crediting period.
                </li>
                <li>
                  <strong>July 2022 (BUS 2021):</strong> Carbon monitoring
                  survey for period V, calculating emission reductions and
                  capturing user perceptions.
                </li>
                <li>
                  <strong>June–August 2023 (Survey 2022):</strong> Fulfilment of
                  second crediting period renewal requirements, with baseline
                  data on potential new users.
                </li>
                <li>
                  <strong>September–October 2024 (Survey 2023):</strong>{" "}
                  Continued monitoring to support ongoing verification of
                  emission reductions.
                </li>
                <li>
                  <strong>November–December 2025 (Survey 2024):</strong> Most
                  recent survey fulfilling monitoring requirements for the next
                  crediting period renewal.
                </li>
              </ol>
              <img
                src={Card3}
                alt="Model Biogas Digester System Slurry"
                className="art-img"
              />

              <h2 className="art-subheading">Significance</h2>
              <p>
                CIRCODU's sustained seven-year engagement with the ABPP Uganda
                programme has made it one of the most experienced biogas carbon
                monitoring organisations in East Africa. The consistency of its
                methodology across multiple monitoring periods has been
                essential to the credibility and continuity of the programme's
                carbon credit generation — ensuring that each new verification
                cycle builds on a coherent, comparable body of field data.
              </p>
              <img
                src={Card4}
                alt="Model Biogas Digester System Slurry Management"
                className="art-img"
              />
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's carbon monitoring and
                biogas services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
